

/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    created() {
        if (this.created)
            this.created();
    },

    mounted() {
        if (this.mounted)
            this.mounted();
    },

    beforeDestroy() {
        if (this.beforeDestroy)
            this.beforeDestroy();
    },

    destroy() {
        if (this.destroy)
            this.destroy();
    },

    computed: {
        cClass() {
            let classes = ['popup'];

            return classes.join(' ');
        },
    },

    methods: {
        mDestroy() {
            this.$emit('destroy');
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Popup extends Vue {
    @Prop() component: any;
    @Prop() componentContent: any;
    @Prop() created: any;
    @Prop() mounted: any;
    @Prop() beforeDestroy: any;
    @Prop() destroy: any;
};
